// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2[data-v-3a828ea2] {\n  margin-bottom: 20px;\n}\n.subtitle[data-v-3a828ea2] {\n  padding-top: 4px;\n  margin-top: -20px;\n  font-size: 12px;\n  line-height: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
